import { useForm } from "react-hook-form";
//primereact
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

import { toast } from "react-toastify";
import { useState } from "react";
import TextareaInput from "../../../../../../../components/input/TextareaInput";
import { patchCancelSale } from "../../../../../../../services/Sales/patchCancelSale";
import { useNavigate } from "react-router-dom";

const ModalStopSale = ({ visible, setVisible, idSale, enterpriseId, location }) => {
    const formStop = useForm();
    const navigate = useNavigate();

    const errors = formStop.formState.errors;
    const [loading, setLoading] = useState(false);

    function sendStopSale(data) {
//        console.log(data);
//        console.log(idSale);
        setLoading(true);
        let obj = { id: idSale, deleted_obs: data.reason }


        const notification = toast.loading(
            "Por favor, aguarde a ação está sendo realizada..."
        );
        patchCancelSale(obj).then(() => {
            setLoading(false);
            toast.update(notification, {
                render: "Contrato estornado com sucesso!",
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                type: "success",
                isLoading: false,
            });
        })
            .catch((error) => {
                setLoading(false);
                toast.update(notification, {
                    render: "Não foi possível estornar o contrato!",
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    type: "error",
                    isLoading: false,
                });
            })
            .finally(() => {
                formStop.reset();
                setVisible(false);
                navigate(`/negotiations/${enterpriseId}`, {
                    state: { name: location.state ? location.state.name : "Empreendimento" }

                });
            });
        setLoading(false)
    }

    const getFormErrorMessage = (name) => {
        return errors[name] ? (
            <small className="p-error">{errors[name].message}</small>
        ) : (
            <small className="p-error">&nbsp;</small>
        );
    };

    return (
        <>
            <Dialog
                header="Motivo do Estorno"
                id="modal_cad"
                className="rounded-4"
                onHide={() => setVisible(false)}
                visible={visible}
                style={{ width: window.innerWidth <= 992 ? "85vw" : "70vw" }}
            >
                <form onSubmit={formStop.handleSubmit(sendStopSale)}>
                    <TextareaInput
                        name="reason"
                        control={formStop.control}
                        label="Digite o motivo do estorno deste contrato"
                        min={20}
                        isRequired={true}
                        errors={formStop.errors}
                    />
                    <div className="col-md-12 d-flex justify-content-end">
                        <Button
                            type="submit"
                            icon="fa-solid fa-check"
                            iconPos="right"
                            label="Confirmar"
                            loading={loading}
                            className="rounded-pill w-70 p-button-danger"
                        />
                    </div>
                </form>
            </Dialog>
        </>
    );
};

export default ModalStopSale;
